import isQA from '../../../utils/isQA';
export const getDaysInTrialRemaining = timestamp => {
  const now = Date.now();
  const hoursRemaining = Math.floor((timestamp - now) / (1000 * 60 * 60));
  return hoursRemaining < 24 && hoursRemaining > 0 ? 1 : Math.floor((timestamp - now) / (1000 * 60 * 60 * 24));
};
export const findEarliestTrial = trials => trials.reduce((earliest, current) => current.endsAt < earliest.endsAt ? current : earliest);
export const ACTIVE_TRIALS_CACHE_TTL = isQA() ? 30000 : 1000 * 60 * 60 * 12; // 30 seconds for QA, 12 hours
export const ACTIVE_TRIALS_STORAGE_KEY = 'hubspot_active_trials';
export const isActiveTrialsCacheStale = ({
  cacheTimestamp
}) => Date.now() - cacheTimestamp > ACTIVE_TRIALS_CACHE_TTL;
const getCachedActiveTrials = portalId => {
  try {
    const cached = window.localStorage.getItem(`${ACTIVE_TRIALS_STORAGE_KEY}_${portalId}`);
    return cached ? JSON.parse(cached) : null;
  } catch (e) {
    return null;
  }
};
const getActiveTrialsWithTimestamp = trials => ({
  trials,
  cacheTimestamp: Date.now()
});
export const activeTrialsCache = {
  get: portalId => {
    return getCachedActiveTrials(portalId);
  },
  set: (portalId, trials) => {
    const cachedData = getActiveTrialsWithTimestamp(trials);
    try {
      window.localStorage.setItem(`${ACTIVE_TRIALS_STORAGE_KEY}_${portalId}`, JSON.stringify(cachedData));
    } catch (e) {
      console.warn('Failed to cache active trials:', e);
    }
  },
  delete: portalId => {
    try {
      window.localStorage.removeItem(`${ACTIVE_TRIALS_STORAGE_KEY}_${portalId}`);
    } catch (e) {
      console.warn('Failed to remove active trials cache:', e);
    }
  }
};
export function trialsCreatedAfterExperimentStart(trials) {
  const experimentStart = new Date('August 4, 2025 00:00:00 UTC');
  return trials.every(trial => {
    const createdAt = new Date(trial.createdAt);
    return createdAt >= experimentStart;
  });
}